module.exports = __webpack_public_path__ + "static/img/content9.6b63b247.png";